import { StyledText } from './Text.styled';

const Text = ({ variant, color, children, ...props }) => {
  return (
    <StyledText $variant={variant} $color={color} {...props}>
      {children}
    </StyledText>
  );
};

export default Text;
